import React, { useState } from 'react';

interface ExpandableSectionProps {
  title: string;
  icon?: string;
  badge?: React.ReactNode;
  defaultExpanded?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  title,
  icon,
  badge,
  defaultExpanded = false,
  children,
  disabled = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  if (disabled) return null;

  return (
    <div className="border border-white/10 bg-black overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between px-4 py-3 bg-black hover:bg-zinc-900/30 transition-colors"
      >
        <div className="flex items-center gap-2">
          {icon && <span className="text-zinc-500 font-mono">{icon}</span>}
          <span className="text-xs uppercase tracking-[0.2em] text-zinc-300 font-mono">{title}</span>
          {badge}
        </div>
        <span className="text-zinc-600 text-xs font-mono">
          {isExpanded ? '−' : '+'}
        </span>
      </button>

      {isExpanded && (
        <div className="p-4 bg-black border-t border-white/10">
          {children}
        </div>
      )}
    </div>
  );
};

export default ExpandableSection;
